import NewAdminNoticeModel from "./model";
import {
  grey_1,
  grey_4,
  grey_6,
  textualBlue,
  posDirectoBlue,
  posDirectoBlueHover,
} from "assets/strings/colors";
import styled from "styled-components";

const NewAdminNotice = styled(NewAdminNoticeModel)`
  #root & {
    margin: 2rem 1rem 0 1rem;
    padding: 1.5rem;
    background: ${grey_1};
    border: 1px solid ${grey_4};
    border-radius: 0.5rem;
    text-align: center;
    > .title {
      color: ${textualBlue};
      margin: 0 0 0.75rem 0;
      font-size: 1.3rem;
      font-weight: bold;
      text-transform: uppercase;
    }
    > .text {
      color: ${grey_6};
      margin: 0 0 1.25rem 0;
      font-size: 1.1rem;
      line-height: 1.5rem;
    }
    > .link {
      display: inline-block;
      padding: 0.9rem 1.5rem;
      background: ${posDirectoBlue};
      color: white;
      font-weight: bold;
      border-radius: 0.25rem;
      text-decoration: none;
    }
    > .link:hover {
      background: ${posDirectoBlueHover};
    }
    > .url {
      color: ${grey_4};
      margin: 0.75rem 0 0 0;
      font-size: 0.9rem;
      word-break: break-all;
    }
  }
`;

export default NewAdminNotice;
